import React, { useState, useEffect } from 'react';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput.js';
import { Form, useFormikContext } from 'formik';
import CommonPincode from '../../../../components/Dashboard-res/CommonComponent/CommonPincode';
import { getPinCodeInfo } from '../../../../common/constants/api';

const Comments = () => {
  const [loading, setLoading] = useState(true);
  const [pincodeStatus, setPincodeStatus] = useState(false);
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = useFormikContext();
  return (
    <div>
      <div className="pincode_field">
        <div className="grid_input_container mb-8">
          <div>
            <CommonPincode
              stylesContainer={{
                minWidth: '100%'
              }}
              name="pincode"
              id="pincode"
              value={values.pincode}
              legendName="Customer Pincode"
              onLoad={
                values.pincode.length == 6 && loading
                  ? (setLoading(false),
                    getPinCodeInfo(values.pincode).then(res => {
                      let data;
                      try {
                        data = res.data[0].PostOffice[0];
                      } catch {
                        data = false;
                      }
                      if (data) {
                        setFieldValue('city', data.District);
                        setFieldValue('state', data.State);
                        setPincodeStatus(true);
                      } else {
                        setFieldError('pincode', 'Pincode is not valid');
                      }
                    }))
                  : null
              }
              onChange={e => {
                pincodeStatus ? setPincodeStatus(false) : null;
                if (e.target.value.length > 6) {
                  return;
                }
                if (e.target.length < 6) {
                  setFieldValue('city', '');
                  setFieldValue('state', '');
                }

                handleChange(e);
              }}
              // error={errors.pincode}
              error={touched.pincode && errors.pincode}
              errorMsg={errors.pincode}
              touched={touched.pincode}
              onPinCodeSucessOrFailure={obj => {
                console.log(obj, 'onPinCodeSucessOrFailure');
                const { err, data } = obj;
                console.log('err, data', err, data);
                if (!err && data) {
                  setFieldValue('city', data.District);
                  setFieldValue('state', data.State);
                  setPincodeStatus(true);
                } else {
                  setFieldError('pincode', 'Pincode is not valid');
                }
              }}
              onBlur={e => {
                handleBlur(e);
              }}
            />
          </div>

          <p className="pt-3 text-green-500 text-xs">
            {values.city} {values.state}
          </p>
        </div>
      </div>
      <div className="email_field">
        <div className="grid_input_container mb-10">
          <div className="email_container">
            <CommonInput
              name="email"
              id="email"
              onChange={handleChange}
              onBlur={e => {
                handleBlur(e);
              }}
              value={values.email}
              stylesContainer={{
                height: '52px',
                maxWidth: '100%'
              }}
              legendName="Email"
              error={touched.email && errors.email}
              errorMsg={errors.email}
              touched={touched.email}
            />
          </div>
        </div>
      </div>
      <h2>Comments</h2>
      <div className="grid_input_container mb-8">
        <div>
          <textarea
            name="comments"
            id="comments"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.comments}
            style={{
              height: '150px',
              minWidth: '100%',
              border: '1px solid #cacaca',
              padding: '10px'
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default Comments;
